'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = require('./SvgIcon');

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ManualStart = (_temp = _class = function (_SvgIcon) {
  _inherits(ManualStart, _SvgIcon);

  function ManualStart() {
    _classCallCheck(this, ManualStart);

    return _possibleConstructorReturn(this, (ManualStart.__proto__ || Object.getPrototypeOf(ManualStart)).apply(this, arguments));
  }

  _createClass(ManualStart, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'svg',
            { width: '64', height: '64' },
            _react2['default'].createElement(
              'defs',
              null,
              _react2['default'].createElement('path', { id: 'a', d: 'M0 .073h8.833v10.78H0z' })
            ),
            _react2['default'].createElement(
              'g',
              { fill: 'none', fillRule: 'evenodd' },
              _react2['default'].createElement('path', {
                fill: '#42E0D0',
                fillRule: 'nonzero',
                d: 'M30 57.971a25.504 25.504 0 0 1-12.153-2.444c-.965-.443-1.9-.948-2.802-1.514-.909-.543-1.742-1.241-2.613-1.862a28.751 28.751 0 0 1-4.543-4.618 31.274 31.274 0 0 1-3.37-5.665 30.293 30.293 0 0 1-2.006-6.364 31.044 31.044 0 0 1-.492-6.752A31.357 31.357 0 0 1 3.08 22l4.58 1.552a25.408 25.408 0 0 0-1.438 5.55 27.516 27.516 0 0 0-.151 5.859 29.882 29.882 0 0 0 1.25 5.743 25.851 25.851 0 0 0 2.536 5.393 29.039 29.039 0 0 0 3.748 4.657c.757.66 1.477 1.397 2.272 1.979a22.003 22.003 0 0 0 2.499 1.707A24.88 24.88 0 0 0 30 57.971'
              }),
              _react2['default'].createElement(
                'g',
                { transform: 'translate(0 15)' },
                _react2['default'].createElement(
                  'mask',
                  { id: 'b', fill: '#fff' },
                  _react2['default'].createElement('use', null)
                ),
                _react2['default'].createElement('path', {
                  fill: '#42E0D0',
                  fillRule: 'nonzero',
                  d: 'M8.833 10.853L8.167.073 0 6.123z',
                  mask: 'url(#b)'
                })
              ),
              _react2['default'].createElement('path', {
                fill: '#FC6666',
                fillRule: 'nonzero',
                d: 'M34 7.003c4.091-.065 8.14.867 11.82 2.718a27.267 27.267 0 0 1 9.57 8.077 30.252 30.252 0 0 1 3.226 5.592 30.703 30.703 0 0 1 1.914 6.33c.377 2.19.527 4.416.45 6.64A33.06 33.06 0 0 1 59.93 43l-4.503-1.553a29.213 29.213 0 0 0 1.426-5.476c.238-1.905.288-3.83.15-5.747a27.004 27.004 0 0 0-1.163-5.708 25.89 25.89 0 0 0-2.402-5.32C49.162 12.206 41.968 7.692 34 7.003'
              }),
              _react2['default'].createElement('path', {
                fill: '#FC6666',
                fillRule: 'nonzero',
                d: 'M55 37l.713 10L64 41.369z'
              }),
              _react2['default'].createElement('path', {
                fill: '#5E6174',
                fillRule: 'nonzero',
                d: 'M30.51 38.397c-3.208-.02-5.793-2.645-5.779-5.865.014-3.22 2.622-5.821 5.83-5.814 3.208.007 5.804 2.62 5.804 5.84-.02 3.231-2.636 5.84-5.855 5.84m17.375-7.838c-.038-.5-.612-.845-1.11-.845a3.942 3.942 0 0 1-3.636-2.42 3.89 3.89 0 0 1 .996-4.342.963.963 0 0 0 .076-1.307 17.334 17.334 0 0 0-2.755-2.804.992.992 0 0 0-1.34.115 4.084 4.084 0 0 1-4.363.999 3.997 3.997 0 0 1-2.373-3.804.96.96 0 0 0-.842-1.037 16.928 16.928 0 0 0-3.942 0 .998.998 0 0 0-.88.999 3.843 3.843 0 0 1-2.373 3.727 4.008 4.008 0 0 1-4.324-1 1.03 1.03 0 0 0-1.34-.114 19.593 19.593 0 0 0-2.832 2.804c-.315.41-.265.994.115 1.345a3.852 3.852 0 0 1 .957 4.38c-.574 1.421-2.067 2.343-3.79 2.343a.916.916 0 0 0-.994.884 17.124 17.124 0 0 0-.039 3.957c.14.522.61.885 1.149.884a3.789 3.789 0 0 1 3.597 2.382 3.93 3.93 0 0 1-.957 4.341.963.963 0 0 0-.115 1.306 17.334 17.334 0 0 0 2.756 2.805.992.992 0 0 0 1.34-.115 4.008 4.008 0 0 1 4.362-.96 3.843 3.843 0 0 1 2.373 3.803.924.924 0 0 0 .842.999c.674.076 1.35.115 2.029.115.64.001 1.278-.037 1.913-.115a.96.96 0 0 0 .88-1 3.92 3.92 0 0 1 2.373-3.726 4.084 4.084 0 0 1 4.363.999.954.954 0 0 0 1.301.115 17.83 17.83 0 0 0 2.833-2.804.963.963 0 0 0-.115-1.345 3.852 3.852 0 0 1-.957-4.341 3.904 3.904 0 0 1 3.56-2.382h.229a.996.996 0 0 0 1.033-.846 17.432 17.432 0 0 0 0-3.995'
              })
            )
          )
        );
      }

      return render;
    }()
  }]);

  return ManualStart;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 64 64'
}, _temp);
exports['default'] = ManualStart;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/SvgIcon/ManualStart.js
// module id = 768
// module chunks = 32